/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_Mock_3Inputs */

const en_cap_agents_mock_3 = /** @type {(inputs: Cap_Agents_Mock_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewer`)
};

const lv_cap_agents_mock_3 = /** @type {(inputs: Cap_Agents_Mock_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzents`)
};

/**
* | output |
* | --- |
* | "Reviewer" |
*
* @param {Cap_Agents_Mock_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_mock_3 = /** @type {((inputs?: Cap_Agents_Mock_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_Mock_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_mock_3(inputs)
	return en_cap_agents_mock_3(inputs)
});